import React from 'react';
import { ShieldCheck } from 'lucide-react';

const SecurityAlerts = ({ alerts }) => {
  if (!alerts || alerts.length === 0) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3">
        <ShieldCheck className="w-5 h-5 text-green-600" />
        <p className="text-sm text-green-700 font-medium">No suspicious adjustments detected</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {alerts.map((alert) => (
        <div key={alert.id} className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <span className="text-lg flex-shrink-0" role="img" aria-label="red flag">
              {'\u{1F6A9}'}
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-semibold text-red-800 truncate">
                  {alert.product_name || 'Unknown Product'}
                  {alert.product_type && (
                    <span className="ml-2 text-xs font-normal text-red-600 capitalize">
                      ({alert.product_type})
                    </span>
                  )}
                </p>
                <span className="text-xs text-red-600 whitespace-nowrap">
                  {new Date(alert.date).toLocaleDateString()}
                </span>
              </div>
              <p className="text-xs text-red-700 mt-1">
                Manual adjustment: <strong>{Math.abs(alert.quantity)}</strong> units
                {alert.quantity > 0 ? ' (increase)' : ' (decrease)'}
                {alert.total_value > 0 && (
                  <span> &mdash; ${alert.total_value.toFixed(2)} total value</span>
                )}
              </p>
              <p className="text-xs text-gray-600 mt-1">
                By: {alert.user_name} | Reason: {alert.reason || 'No reason provided'}
              </p>
              <div className="flex gap-2 mt-2">
                {alert.flags.includes('high_quantity') && (
                  <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full font-medium">
                    High Quantity (&gt;10)
                  </span>
                )}
                {alert.flags.includes('high_value') && (
                  <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full font-medium">
                    High Value (&gt;$500)
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SecurityAlerts;
